// Module
var code = "<p>Front end engineering for Wall Street Journal, Barrons, Marketwatch etc.</p>";
// Exports
export default code;